import React from 'react';
import { Field } from './Primitives';
import { HeartbeatIndicator } from './VmMeta';
import VmIpAddress from './VmIpAddress';
import { pick, formatMemoryMb, formatMhz, formatUptime } from '../utils/format';

/**
 * Griglia dettagliata delle informazioni di una VM. Consuma sia i campi
 * documentati dell'elenco (`guest`, `resources`) sia gli eventuali campi extra
 * del dettaglio (`os`, `datastore`, …) tramite accessori difensivi: i campi non
 * presenti mostrano "—", nessun valore viene inventato. Non vengono mai
 * mostrati UUID, VMID, comandi, chiavi o percorsi interni.
 */
export default function VmDetailFields({ vm }) {
  const guest = vm.guest || {};
  const res = vm.resources || {};

  const os = pick(vm, ['os', 'guestOs', 'guestFullName', 'operatingSystem']);
  const datastore = pick(vm, ['datastore', 'datastoreName']);
  const tools =
    pick(guest, ['toolsRunningStatus', 'toolsStatus']) ??
    pick(vm, ['toolsStatus']);
  const health = pick(vm, ['overallStatus', 'health', 'status', 'generalStatus']);

  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-3 lg:grid-cols-4">
      <Field label="Ruolo">{vm.role}</Field>
      <Field label="IP principale"><VmIpAddress vm={vm} compact /></Field>
      <Field label="IP rilevato">{guest.ipAddress}</Field>
      <Field label="IP attesi">{vm.expectedIps?.join(', ')}</Field>
      <Field label="Hostname guest">{guest.hostName}</Field>
      <Field label="Sistema operativo">{os}</Field>
      <Field label="vCPU">{res.vcpus}</Field>
      <Field label="RAM configurata">{formatMemoryMb(res.memoryMb)}</Field>
      <Field label="Consumo CPU">{formatMhz(res.cpuUsageMhz)}</Field>
      <Field label="Memoria guest">{formatMemoryMb(res.guestMemoryUsageMb)}</Field>
      <Field label="Memoria host">{formatMemoryMb(res.hostMemoryUsageMb)}</Field>
      <Field label="Uptime">{formatUptime(res.uptimeSeconds)}</Field>
      <Field label="VMware Tools">{tools}</Field>
      <Field label="Heartbeat">
        {guest.heartbeatStatus ? (
          <HeartbeatIndicator status={guest.heartbeatStatus} />
        ) : (
          '—'
        )}
      </Field>
      <Field label="Datastore">{datastore}</Field>
      <Field label="Stato generale">{health}</Field>
    </dl>
  );
}
